import React, { useCallback, useEffect, useReducer, useRef } from 'react';
import Modal from "react-modal";
import "./style.scss";
import classNames from "classnames";
import IconButton from "../IconButton";
import MenuService from "../../../services/menu";
import SideMenu from "../SideMenu";
import {getHistoryLocationParams} from "../../../utils/routesHelper";

export const SectionItemMobileMenu = ({column, item}) => {
    const [,forceUpdate] = useReducer(n => n + 1, 0);
    const { accessor, iconName, tooltipText, menuType } = column;
    const showMenu = useRef(false);
    const touchstartY = useRef(0);

    useEffect(() => {
        const {id} = getHistoryLocationParams(window.location.search);
        if(id === item.id) {
            setShowMenu(true);
        }
    }, [item])

    const touchStart = useCallback((e) => {
        touchstartY.current = e.changedTouches[0].screenY;
    }, []);

    const checkDirection = useCallback((touchendY) => {
        if (touchendY > touchstartY.current && touchendY - touchstartY.current > 50 && showMenu.current) {
            const miwWithForClose = showMenu.current ? 300 : 350
            const maxWithForClose = showMenu.current ? 500 : 450
            const isCloseModalMenu = touchendY > miwWithForClose && touchendY < maxWithForClose
            if(isCloseModalMenu) {
                setShowMenu(false);
                window.history.pushState({}, "", window.location.pathname)
            }
        }
    }, []);

    const touchEnd = useCallback((e) => {
        const touchendY = e.changedTouches[0].screenY;
        checkDirection(touchendY)
    }, [checkDirection]);

    useEffect(() => {
        document.addEventListener("touchstart", touchStart);
        document.addEventListener("touchend", touchEnd)

        return () => {
            document.removeEventListener("touchstart", touchStart);
            document.removeEventListener("touchend", touchEnd);
        };
    }, [touchStart, touchEnd, checkDirection]);

    const handleOnClick = () => {
        const url = new URL(window.location);
        url.searchParams.set("id", item[column.key] || '');
        window.history.pushState({}, "", url);
        setShowMenu(true)
    }

    const setShowMenu = flag => {
        showMenu.current = flag
        forceUpdate();
    }

    return (
        <div key={`propItem-${accessor}`} className={classNames("sectionItemMobileMenu")}>
            <IconButton isIcon iconName={iconName} onClick={handleOnClick} tooltipText={tooltipText}/>
            {showMenu.current && (
                <Modal isOpen={showMenu.current} overlayClassName={"mobileMenuOverlay"} className={"mobileMenuModal"}>
                    <div className={"hr"}></div>
                    <SideMenu clickedNested={true} menu={MenuService.instance.getMenu(menuType)}/>
                </Modal>
            )}
        </div>
    );
}